import { get, type Writable, writable } from 'svelte/store';
import type { Achievement } from '../domain/Achievement';

export const achievementsStore: Writable<Achievement[]> = writable();

export const findAchievementById = (id: string) => {
	const achievements = get(achievementsStore);

	return achievements.find(({ achievementId }) => achievementId === id);
};

export const findAchievementByName = (name: string): Achievement | undefined => {
	const achievements = get(achievementsStore);

	return achievements.find((achievement) => achievement.name === name);
};

export const findAll = (): Achievement[] => {
	return get(achievementsStore);
};

